import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";

import {
  PluggableList,
  ReactMarkdown,
  ReactMarkdownOptions,
} from "react-markdown/lib/react-markdown";

import { css } from "@emotion/react";

import { parseMentions } from "utils/mention";

import { black } from "constants/colors";

const style = {
  markdown: css({
    "& img": {
      maxWidth: "100%",
      height: "auto",
    },
    "& pre": {
      whiteSpace: "break-spaces",
    },
    "& a[href*='profiles/']": {
      color: black,
      textDecoration: "none",
      fontWeight: "bold",
    },
    "& a[href*='org/']": {
      color: black,
      textDecoration: "none",
      fontWeight: "bold",
    },
  }),
};

type Props = ReactMarkdownOptions & {
  replaceNewlines?: boolean;
  dangerouslyEnableHtml?: boolean;
};

// we do not control the options of the markdown component
export const Markdown = ({
  replaceNewlines,
  dangerouslyEnableHtml,
  ...options
}: Props) => {
  return (
    <ReactMarkdown
      linkTarget="_blank"
      remarkPlugins={[remarkGfm]}
      css={style.markdown}
      rehypePlugins={
        dangerouslyEnableHtml ? ([rehypeRaw] as PluggableList) : undefined
      }
      {...options}
    >
      {parseMentions(
        replaceNewlines
          ? options.children.replace(/\n/g, "  \n&nbsp;  \n")
          : options.children
      )}
    </ReactMarkdown>
  );
};
